export const STRAPI_DEV_TOKEN = process.env.NEXT_PUBLIC_STRAPI_DEV_API_TOKEN;
export const STRAPI_BASE_URL = process.env.NEXT_PUBLIC_STRAPI_BASE_URL;
export const STRAPI_IS_LOCAL_ENV = process.env.NEXT_PUBLIC_STRAPI_IS_LOCAL_ENV;

export const HERO_SECTION_DATA_KEY = 'hero-section-data';
